export const FEATURE_SUGGESTION_MIN_TEXT_LENGTH = 20;
export const initialErrorState = { categories: '', text: '' };

export const categories = [
  { value: 'Analytics', label: 'common_analytics' },
  { value: 'Documentation', label: 'common_documentation' },
  { value: 'Settlement and Report', label: 'common_report' },
  { value: 'Send Money', label: 'common_send_money' },
  { value: 'Receive Money', label: 'common_receive_money' },
  { value: 'Cash Management', label: 'common_cashManagement' },
  { value: 'Expense Management', label: 'common_expenseManagement' },
  { value: 'Invoice', label: 'common_invoice' },
  { value: 'Supporting Feature', label: 'common_supportingFeature' },
  { value: 'Other', label: 'common_other' },
] as const;

export type CategoryLabel = (typeof categories)[number]['label'];

export const GENERAL_LABEL: Array<(typeof categories)[number]['label']> = [
  'common_analytics',
  'common_documentation',
  'common_report',
  'common_other',
];
